module.exports = __webpack_public_path__ + "img/safari.b588d1bf.svg";